export default {
      id: "viewMore-usage",
      viewBox: "0 0 3 15",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#viewMore",
      toString: function () {
        return this.url;
      }
    }